import React, { useEffect, useState }     from 'react';
import { Box, Typography, IconButton }    from '@mui/material';
import UploadFileIcon                     from '@mui/icons-material/UploadFile';
import DeleteForeverIcon                  from '@mui/icons-material/DeleteForever';

const CustomDragAndDrop = ({ onFilesAdded, resetFile, enabled, id, onResetFiles }) => {

  const [dragActive, setDragActive] = useState(false);
  const [fileNames,  setFileNames ] = useState([]);

  useEffect(() => {
    if (resetFile) {
      setFileNames([]);
    }
  }, [resetFile]);

  const handleDrag = (e) => {
    if (!enabled) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragover' || e.type === 'dragenter') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    if (!enabled) return;
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    const files = Array.from(e.dataTransfer.files);
    setFileNames((prevFileNames) => [...prevFileNames, ...files.map((file) => file.name)]);
    
    if (onFilesAdded) {
      onFilesAdded(files);
    }

    e.target.value = null;
  };

  const handleFileClick = () => {
    if (!enabled) return;
    document.getElementById(id).click();
  };

  const handleFileChange = (e) => {
    if (!enabled) return;
    const files = Array.from(e.target.files);
    setFileNames((prevFileNames) => [...prevFileNames, ...files.map((file) => file.name)]);
    
    if (onFilesAdded) {
      onFilesAdded(files);
    }

    e.target.value = null;
  };

  const handleReset = (e) => {
    e.stopPropagation(); 
    setFileNames([]);
    if (onResetFiles) {
      onResetFiles();
    }
  };

  const renderFileNames = () => {
    if (fileNames.length === 0) {
      return 'Click or drag a file to this area to upload';
    }
    const firstFiles = fileNames.slice(0, 2);
    return (
      <>
        {firstFiles.join(', ')} {fileNames.length > 2 && '...'}
      </>
    );
  };

  return (
    <Box
      sx={{
        position: 'relative', 
        border: '1px dashed #fda03d',
        padding: '16px',
        textAlign: 'center',
        borderRadius: '8px',
        color: '#999',
        flexDirection: 'column',
        backgroundColor: dragActive ? '#f8f9fa' : 'transparent',
        opacity: enabled ? 1 : 0.5,
        cursor: enabled ? 'pointer' : 'not-allowed',
      }}
      onDragEnter={handleDrag}
      onDragOver={handleDrag}
      onDragLeave={handleDrag}
      onDrop={handleDrop}
      onClick={handleFileClick}
    >
      <UploadFileIcon sx={{ color: enabled ? '#000' : '#999' }} />
      <Typography>{renderFileNames()}</Typography>
      <input
        type="file"
        id={id}
        multiple
        style={{ display: 'none' }}
        onChange={handleFileChange}
        disabled={!enabled}
      />
      {fileNames.length > 0 && (
        <IconButton
          onClick={handleReset}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'red',
            '&:hover': {
              bgcolor: 'transparent',
              transform: 'scale(1.02)',
              color: '#d60000'
            }
          }}
          aria-label="delete"
        >
          <DeleteForeverIcon />
        </IconButton>
      )}
    </Box>
  );
};

export default CustomDragAndDrop;
